export default __webpack_public_path__ + "static/media/certificate.5ac8b9e2.svg";